export default __webpack_public_path__ + "static/media/QK_9755.b764a8c3.jpg";